(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["combined-product-specs"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('combined-product-specs')) {
  customElements.define('combined-product-specs', class extends HTMLElement {
    connectedCallback() {
      if (this.onToggle) return;
      this.onToggle = (event) => {
        const toggle = event.target.closest('.spec-table__toggle');
        if (!toggle || !this.contains(toggle)) return;
        const body = document.getElementById(toggle.getAttribute('aria-controls'));
        if (!body || !this.contains(body)) return;
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!expanded));
        body.classList.toggle('is-collapsed', expanded);
      };
      this.addEventListener('click', this.onToggle);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onToggle);
      this.onToggle = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-bike-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bike-home-finder')) {
    customElements.define('bike-home-finder', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => { if (this.isConnected) this.initialize(); });
      }
      initialize() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.form = this.querySelector('form');
        const seen = new Set();
        this.bikes = Array.from(this.querySelectorAll('[data-bike]')).filter(bike => {
          if (seen.has(bike.dataset.productId)) { bike.hidden = true; return false; }
          seen.add(bike.dataset.productId);
          return true;
        });
        if (!this.bikes.length) return;
        this.form.hidden = false;
        this.form.addEventListener('submit', event => event.preventDefault(), { signal });
        this.form.addEventListener('input', () => this.filter(), { signal });
        this.form.addEventListener('reset', () => setTimeout(() => { if (this.isConnected) this.filter(); }, 0), { signal });
        this.addEventListener('shopify:block:select', event => {
          const bike = this.bikes.find(item => item.dataset.blockId === event.detail.blockId);
          if (!bike) return;
          this.form.reset();
          setTimeout(() => {
            if (!this.isConnected) return;
            this.form.elements.stock_only.checked = false;
            this.filter();
            bike.scrollIntoView({ block: 'nearest', behavior: 'auto' });
          }, 0);
        }, { signal });
        this.filter();
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; }
      filter() {
        const fields = this.form.elements;
        this.matches = this.bikes.filter(bike => {
          const fits = ['wheel_size', 'edition', 'brakes'].every(key => {
            const attr = key === 'wheel_size' ? 'wheelSize' : key;
            return fields[key].value === 'any' || fields[key].value === bike.dataset[attr];
          });
          return fits && (!fields.stock_only.checked || bike.dataset.available === 'true');
        });
        this.querySelector('[data-count]').textContent = this.dataset.results.replace('__COUNT__', this.matches.length);
        const matches = new Set(this.matches);
        this.bikes.forEach(bike => { bike.hidden = !matches.has(bike); });
        this.querySelector('[data-empty]').hidden = this.matches.length > 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
